import { jsxs, jsx } from 'react/jsx-runtime';
import { Icon } from '../icon/icon.component.js';
import { StyledLink } from './back-link.style.js';

const BackLink = props => {
    const { children, color } = props;
    const iconProps = {
        color: color !== null && color !== void 0 ? color : 'primary',
        icon: 'ChevronLeft',
        margin: { right: '8px' },
    };
    return (jsxs(StyledLink, Object.assign({}, props, { children: [jsx(Icon, Object.assign({}, iconProps), void 0), children] }), void 0));
};

export { BackLink };
